import { render } from "./ClientRankingChart.vue?vue&type=template&id=4853470e&scoped=true"
import script from "./ClientRankingChart.vue?vue&type=script&lang=js"
export * from "./ClientRankingChart.vue?vue&type=script&lang=js"

import "./ClientRankingChart.vue?vue&type=style&index=0&id=4853470e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4853470e"]])

export default __exports__